import React from "react";
import { TextField, makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  input: {
    width: 90,
    "& input": {
      padding: "4px 6px",
      fontSize: "0.85rem",
      textAlign: "right",
    },
  },
});

export default function EditableForecastCell({ row, cellKey, editBuffer, onCellChange }) {
  const classes = useStyles();
  const key = cellKey !== undefined ? cellKey : row.collabrixForecastDetailID;
  const buffered = editBuffer[key];
  const value = buffered !== undefined ? buffered : row.quantity;

  const onChange = (e) => {
    const v = e.target.value;
    if (v === "") {
      onCellChange(key, 0);
      return;
    }
    const num = Number(v);
    if (Number.isNaN(num) || num < 0) return;
    onCellChange(key, num);
  };

  return (
    <TextField
      className={classes.input}
      type="number"
      size="small"
      variant="outlined"
      value={value}
      onChange={onChange}
      inputProps={{ min: 0 }}
    />
  );
}
